export default function Policy() {
    return(
        <div className="has-text-left">
        <h1 className="title">Polityka prywatności</h1>
        <h2 className="title">ZGODA NA PRZETWARZANIE DANYCH OSOBOWYCH</h2>
        <p>Wyrażam zgodę na przetwarzanie moich danych osobowych w zakresie:</p>
        <ul>
        <li>a) imienia, nazwiska, adresu e-mail oraz nazwy firmy/organizacji - w celu przeprowadzenia konkursu, wyłonienia zwycięzców i ogłoszenia wyników konkursu;</li>
        <li>b) imienia, nazwiska, numeru PESEL, adresu i numeru telefonu - w celu przekazania nagród laureatom konkursu;</li>
        <li>c) wizerunku - w celu opublikowanianpm run build relacji zdjęciowo-tekstowej z konkursu na profilu (fanpage'u) firmy JohnnyBros na Facebooku i Instagramie
        przez JohnnyBros sp. z o.o., ul. Strzelecka 7B, 80-803 Gdańsk.</li>
        </ul>
        <p>Zgodnie z art. 13 ust. 1 i ust. 2 ogólnego rozporządzenia o ochronie danych osobowych z dnia 27 kwietnia 2016 r. informujemy, iż administratorem danych, w rozumieniu art. 4 pkt 7 Rozporządzenia z dnia 27 kwietnia 2016 r. o ochronie danych osobowych zawartych w niniejszym oświadczeniu jest JohnnyBros sp. z o.o. siedzibą przy ul. Strzeleckiej 7B, 80-803 Gdańsk, REGON: 220724510, NIP: 2040002265.</p>
        </div>
        );
}